import axios from '@/resources/libs/axios'

export default {
    list() {
        return axios.get(`/gei/auxiliaries/opsva-territories/list/all`)
    },
}